var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.loading
    ? _c(
        "div",
        { staticClass: "checkout-success" },
        [
          _vm.tokenValue
            ? [
                _vm.isOrderTypeMain ||
                _vm.isOrderTypeCourse ||
                _vm.isOrderTypeVoucher ||
                _vm.isOrderTypeVoucherReload ||
                _vm.isOrderTypeGastroKurier
                  ? [
                      _c("h1", {
                        staticClass: "checkout-success__headline",
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("checkout.success.title"))
                        }
                      }),
                      _vm._v(" "),
                      _vm.hasFeature("FEATURE_LIVE_ORDER_STATE")
                        ? _c("LiveOrderStates", {
                            attrs: { tokenValues: [_vm.tokenValue] }
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.showRewardzTeaser
                        ? _c(
                            "div",
                            { staticClass: "checkout-success__rewardz" },
                            [
                              _c("img", {
                                staticClass: "checkout-success__rewardz-logo",
                                attrs: {
                                  src: _vm.themeImagePath("brand-rewardz.svg"),
                                  alt: "Rewardz"
                                }
                              }),
                              _vm._v(" "),
                              _c("h3", {
                                staticClass: "checkout-success__title",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("checkout.success.rewardz.title")
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c("div", {
                                staticClass: "checkout-success__text",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$t("checkout.success.rewardz.text")
                                  )
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "checkout-success__rewardz-buttons"
                                },
                                [
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "checkout-success__rewardz-button",
                                      attrs: {
                                        href: _vm.$t(
                                          "checkout.success.rewardz.playStoreUrl"
                                        ),
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: _vm.themeImagePath(
                                            "google-play-badge.svg"
                                          ),
                                          alt: "Get it on Google Play"
                                        }
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "a",
                                    {
                                      staticClass:
                                        "checkout-success__rewardz-button",
                                      attrs: {
                                        href: _vm.$t(
                                          "checkout.success.rewardz.appStoreUrl"
                                        ),
                                        target: "_blank"
                                      }
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: _vm.themeImagePath(
                                            "app-store-badge.svg"
                                          ),
                                          alt: "Download on the App Store"
                                        }
                                      })
                                    ]
                                  )
                                ]
                              )
                            ]
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c("h2", {
                        staticClass: "checkout-success__subheadline",
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("checkout.success.subTitle"))
                        }
                      })
                    ]
                  : _vm.isOrderTypeReusableDishes
                  ? [
                      _c("h1", {
                        staticClass: "checkout-success__headline",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("checkout.success.titleDishes")
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c("h2", {
                        staticClass: "checkout-success__subheadline",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("checkout.success.subTitleDishes")
                          )
                        }
                      })
                    ]
                  : _vm.isOrderTypeTip
                  ? [
                      _c("h1", {
                        staticClass: "checkout-success__headline",
                        domProps: {
                          innerHTML: _vm._s(_vm.$t("checkout.success.titleTip"))
                        }
                      }),
                      _vm._v(" "),
                      _c("h2", {
                        staticClass: "checkout-success__subheadline",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("checkout.success.subTitleTip")
                          )
                        }
                      })
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "ul",
                  { staticClass: "checkout-success__info" },
                  [
                    _vm.cartIsUberDirect
                      ? _c(
                          "li",
                          { staticClass: "checkout-success__info-partner" },
                          [
                            _c("div", {
                              staticClass:
                                "checkout-success__info-partner-text",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("uberDirect.deliveryBy")
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("SVGUberDirect", {
                              staticClass: "checkout-success__info-partner-logo"
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    !_vm.isOrderTypeVoucher && !_vm.isOrderTypeVoucherReload
                      ? _c(
                          "li",
                          { staticClass: "checkout-success__info-item" },
                          [
                            _c("SVGLocation"),
                            _vm._v(" "),
                            _c("span", {
                              domProps: { innerHTML: _vm._s(_vm.channelName) }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "li",
                      { staticClass: "checkout-success__info-item" },
                      [
                        _c("SVGDate"),
                        _vm._v(" "),
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.deliveryDate) }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    !_vm.timeDisabled
                      ? _c(
                          "li",
                          { staticClass: "checkout-success__info-item" },
                          [
                            _c("SVGClock"),
                            _vm._v(" "),
                            _c("span", {
                              domProps: { innerHTML: _vm._s(_vm.deliveryTime) }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.shippingMethod && !_vm.isOrderTypeTip
                      ? _c(
                          "li",
                          { staticClass: "checkout-success__info-item" },
                          [
                            _vm.shippingMethod && _vm.shippingMethod.code
                              ? _c(
                                  _vm.shippingMethodIconComponent(
                                    _vm.shippingMethod.code
                                  ),
                                  { tag: "component" }
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c("span", {
                              domProps: {
                                innerHTML: _vm._s(_vm.shippingMethod.name)
                              }
                            })
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm._l(_vm.payments, function(payment, i) {
                      return !_vm.paymentDisabled
                        ? _c(
                            "li",
                            {
                              key: "payment-" + i,
                              staticClass: "checkout-success__info-item"
                            },
                            [
                              _c(
                                _vm.iconComponent(payment.method.code) ||
                                  _vm.iconComponent("datatrans"),
                                { tag: "component" }
                              ),
                              _vm._v(" "),
                              _c("span", {
                                domProps: {
                                  innerHTML: _vm._s(payment.method.name)
                                }
                              })
                            ],
                            1
                          )
                        : _vm._e()
                    })
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.isOrderTypeMain ||
                _vm.isOrderTypeCourse ||
                _vm.isOrderTypeVoucher ||
                _vm.isOrderTypeVoucherReload ||
                _vm.isOrderTypeReusableDishes ||
                _vm.isOrderTypeGastroKurier
                  ? [
                      !_vm.isOutdoorDelivery
                        ? [
                            !_vm.shippingAddressDisabled ||
                            !_vm.billingAddressDisabled
                              ? _c(
                                  "div",
                                  { staticClass: "checkout-success__address" },
                                  [
                                    !_vm.billingAddressDisabled
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "checkout-success__address-billing"
                                          },
                                          [
                                            _c("h3", {
                                              staticClass:
                                                "checkout-success__title",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$t(
                                                    "checkout.success.billingAddress"
                                                  )
                                                )
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("address", {
                                              directives: [
                                                {
                                                  name: "sanitize",
                                                  rawName: "v-sanitize",
                                                  value: _vm.formatAddress(
                                                    _vm.billingAddress
                                                  ),
                                                  expression:
                                                    "formatAddress(billingAddress)"
                                                }
                                              ]
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    !_vm.shippingAddressDisabled &&
                                    _vm.isDelivery &&
                                    (!_vm.cartIsUberDirect ||
                                      !_vm.cartShippingCoordinates)
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "checkout-success__address-shipping"
                                          },
                                          [
                                            _c("h3", {
                                              staticClass:
                                                "checkout-success__title",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$t(
                                                    "checkout.success.shippingAddress"
                                                  )
                                                )
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("address", {
                                              directives: [
                                                {
                                                  name: "sanitize",
                                                  rawName: "v-sanitize",
                                                  value: _vm.formatAddress(
                                                    _vm.shippingAddress
                                                  ),
                                                  expression:
                                                    "formatAddress(shippingAddress)"
                                                }
                                              ]
                                            })
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.cartIsUberDirect && _vm.cartShippingCoordinates
                              ? _c(
                                  "div",
                                  { staticClass: "checkout-success__address" },
                                  [
                                    !_vm.shippingAddressDisabled &&
                                    _vm.isDelivery
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "checkout-success__address-shipping"
                                          },
                                          [
                                            _c("h3", {
                                              staticClass:
                                                "checkout-success__title",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  _vm.$t(
                                                    "checkout.success.shippingAddress"
                                                  )
                                                )
                                              }
                                            }),
                                            _vm._v(" "),
                                            _c("address", {
                                              directives: [
                                                {
                                                  name: "sanitize",
                                                  rawName: "v-sanitize",
                                                  value: _vm.formatAddress(
                                                    _vm.shippingAddress
                                                  ),
                                                  expression:
                                                    "formatAddress(shippingAddress)"
                                                }
                                              ]
                                            })
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "checkout-success__address-map"
                                      },
                                      [
                                        _c("MapLocations", {
                                          key: _vm.cartShippingCoordinates,
                                          attrs: {
                                            locations: [
                                              Object.assign(
                                                {},
                                                {
                                                  id: 1,
                                                  title: _vm.$t(
                                                    "checkout.success.shippingAddress"
                                                  )
                                                },
                                                _vm.cartShippingCoordinates
                                              )
                                            ]
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  ]
                                )
                              : _vm._e()
                          ]
                        : [
                            _c(
                              "div",
                              { staticClass: "checkout-success__address" },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "checkout-success__address-outdoor"
                                  },
                                  [
                                    _c("h3", {
                                      staticClass: "checkout-success__title",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t(
                                            "checkout.success.shippingAddress"
                                          )
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "checkout-form__outdoor-delivery"
                                      },
                                      [
                                        _vm.cartOutdoorDeliveryPoint.image &&
                                        _vm.cartOutdoorDeliveryPoint.image.path
                                          ? _c(
                                              "figure",
                                              {
                                                staticClass:
                                                  "checkout-form__outdoor-delivery-image checkout-form__outdoor-delivery-image--full"
                                              },
                                              [
                                                _c("img", {
                                                  staticClass:
                                                    "checkout-form__outdoor-delivery-image-element",
                                                  attrs: {
                                                    src:
                                                      _vm
                                                        .cartOutdoorDeliveryPoint
                                                        .image.path,
                                                    alt:
                                                      "outdoor delivery point image"
                                                  }
                                                })
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c("address", {
                                          directives: [
                                            {
                                              name: "sanitize",
                                              rawName: "v-sanitize",
                                              value: _vm.outdoorDeliveryAddress,
                                              expression:
                                                "outdoorDeliveryAddress"
                                            }
                                          ],
                                          staticClass:
                                            "checkout-form__outdoor-delivery-address"
                                        }),
                                        _vm._v(" "),
                                        _c("Button", {
                                          staticClass:
                                            "checkout-form__outdoor-delivery-link",
                                          attrs: {
                                            type: "button",
                                            href:
                                              "http://www.google.com/maps/place/" +
                                              _vm.cartOutdoorDeliveryPoint
                                                .latitude +
                                              "," +
                                              _vm.cartOutdoorDeliveryPoint
                                                .longitude,
                                            target: "_blank",
                                            level: "tertiary",
                                            arrow: "",
                                            text: _vm.$t(
                                              "checkout.outdoorDelivery.googleMapsLink"
                                            )
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("h3", {
                                      staticClass: "checkout-success__title",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$t("checkout.personalData")
                                        )
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("address", {
                                      directives: [
                                        {
                                          name: "sanitize",
                                          rawName: "v-sanitize",
                                          value: _vm.formatAddress({
                                            firstName:
                                              _vm.shippingAddress.firstName,
                                            lastName:
                                              _vm.shippingAddress.lastName,
                                            phoneNumber:
                                              _vm.shippingAddress.phoneNumber
                                          }),
                                          expression:
                                            "formatAddress({firstName: shippingAddress.firstName, lastName: shippingAddress.lastName, phoneNumber: shippingAddress.phoneNumber})"
                                        }
                                      ]
                                    })
                                  ]
                                )
                              ]
                            )
                          ],
                      _vm._v(" "),
                      _vm.dropoffType && !_vm.dropoffDisabled
                        ? [
                            _c("h3", {
                              staticClass: "checkout-success__title",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("checkout.dropoff.title")
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "checkout-success__text",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("checkout.dropoff." + _vm.dropoffType)
                                )
                              }
                            })
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.notes && !_vm.notesDisabled
                        ? [
                            _c("h3", {
                              staticClass: "checkout-success__title",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("checkout.success.notes")
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              directives: [
                                {
                                  name: "sanitize",
                                  rawName: "v-sanitize",
                                  value: _vm.$options.filters.fwgcmstext(
                                    _vm.notes
                                  ),
                                  expression:
                                    "$options.filters.fwgcmstext(notes)"
                                }
                              ],
                              staticClass: "checkout-success__text"
                            })
                          ]
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.useDishes && !_vm.reusableDishDisabled
                        ? [
                            _c("h3", {
                              staticClass: "checkout-success__title",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("checkout.reusableDishes.successTitle")
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("div", {
                              staticClass: "checkout-success__text",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("checkout.reusableDishes.successText")
                                )
                              }
                            })
                          ]
                        : _vm._e()
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c("h3", {
                  staticClass: "checkout-success__title",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("checkout.success.order"))
                  }
                }),
                _vm._v(" "),
                _vm.hasFeature("FEATURE_GROUP_ORDERS") && _vm.cartIsGroupOrder
                  ? [
                      _c(
                        "ul",
                        { staticClass: "checkout-success__items" },
                        [
                          _vm._l(_vm.groupOrderParticipantsEnhanced, function(
                            participant
                          ) {
                            return [
                              _c("li", {
                                directives: [
                                  {
                                    name: "sanitize",
                                    rawName: "v-sanitize",
                                    value: participant.name,
                                    expression: "participant.name"
                                  }
                                ],
                                key: participant.id,
                                staticClass:
                                  "checkout-success__item checkout-success__item--participant"
                              }),
                              _vm._v(" "),
                              _vm._l(participant.items, function(item) {
                                return _c(
                                  "li",
                                  {
                                    key: "item-" + item.id,
                                    staticClass: "checkout-success__item"
                                  },
                                  [
                                    _c("span", {
                                      staticClass:
                                        "checkout-success__item-quantity",
                                      domProps: {
                                        innerHTML: _vm._s(item.quantity)
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "span",
                                      {
                                        staticClass:
                                          "checkout-success__item-name"
                                      },
                                      [
                                        _c("span", {
                                          domProps: {
                                            innerHTML: _vm._s(item.displayName)
                                          }
                                        }),
                                        _vm._v(" "),
                                        item.allOptions
                                          ? _c("span", {
                                              staticClass:
                                                "checkout-success__item-options",
                                              domProps: {
                                                innerHTML: _vm._s(
                                                  item.allOptions
                                                )
                                              }
                                            })
                                          : _vm._e()
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c("span", {
                                      staticClass:
                                        "checkout-success__item-price",
                                      domProps: {
                                        innerHTML: _vm._s(
                                          _vm.$options.filters.fwgpricecent(
                                            item.originalTotal,
                                            "short"
                                          )
                                        )
                                      }
                                    })
                                  ]
                                )
                              })
                            ]
                          })
                        ],
                        2
                      )
                    ]
                  : [
                      _c(
                        "ul",
                        { staticClass: "checkout-success__items" },
                        _vm._l(_vm.itemsEnhanced, function(item) {
                          return _c(
                            "li",
                            {
                              key: "item-" + item.id,
                              staticClass: "checkout-success__item"
                            },
                            [
                              _c("span", {
                                staticClass: "checkout-success__item-quantity",
                                domProps: { innerHTML: _vm._s(item.quantity) }
                              }),
                              _vm._v(" "),
                              _c(
                                "span",
                                { staticClass: "checkout-success__item-name" },
                                [
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(item.displayName)
                                    }
                                  }),
                                  _vm._v(" "),
                                  item.allOptions
                                    ? _c("span", {
                                        staticClass:
                                          "checkout-success__item-options",
                                        domProps: {
                                          innerHTML: _vm._s(item.allOptions)
                                        }
                                      })
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "checkout-success__item-price",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$options.filters.fwgpricecent(
                                      item.originalTotal,
                                      "short"
                                    )
                                  )
                                }
                              })
                            ]
                          )
                        }),
                        0
                      )
                    ],
                _vm._v(" "),
                _vm.additionalItems.length
                  ? [
                      _c("h3", {
                        staticClass: "checkout-success__title",
                        domProps: {
                          innerHTML: _vm._s(
                            _vm.$t("checkout.success.additionalProducts")
                          )
                        }
                      }),
                      _vm._v(" "),
                      _c(
                        "ul",
                        { staticClass: "checkout-success__items" },
                        _vm._l(_vm.additionalItems, function(item) {
                          return _c(
                            "li",
                            {
                              key: "item-" + item.id,
                              staticClass: "checkout-success__item"
                            },
                            [
                              _c("span", {
                                staticClass: "checkout-success__item-quantity",
                                domProps: { innerHTML: _vm._s(item.quantity) }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "checkout-success__item-name",
                                domProps: { innerHTML: _vm._s(item.name) }
                              }),
                              _vm._v(" "),
                              _c("span", {
                                staticClass: "checkout-success__item-price",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.$options.filters.fwgpricecent(
                                      item.originalTotal,
                                      "short"
                                    )
                                  )
                                }
                              })
                            ]
                          )
                        }),
                        0
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "checkout-success__summary" },
                  [
                    _vm._l(_vm.discounts, function(discount) {
                      return _c(
                        "div",
                        {
                          key: discount.name,
                          staticClass:
                            "checkout-success__summary-row checkout-success__summary-row--discount"
                        },
                        [
                          _c("span", {
                            staticClass: "checkout-success__summary-row-title",
                            domProps: { innerHTML: _vm._s(discount.name) }
                          }),
                          _vm._v(" "),
                          _c("span", {
                            staticClass: "checkout-success__summary-row-price",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$options.filters.fwgpricecent(
                                  discount.amount.current,
                                  "short"
                                )
                              )
                            }
                          })
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _vm.isDelivery && _vm.deliveryPrice
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "checkout-success__summary-row checkout-success__summary-row--shipping"
                          },
                          [
                            _c("span", {
                              staticClass:
                                "checkout-success__summary-row-title",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("checkout.success.deliveryFee")
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("span", {
                              staticClass:
                                "checkout-success__summary-row-price",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$options.filters.fwgpricecent(
                                    _vm.deliveryPrice,
                                    "short"
                                  )
                                )
                              }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.cartCo2Compensation
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "checkout-success__summary-row checkout-success__summary-row--co2"
                          },
                          [
                            _c("span", {
                              staticClass:
                                "checkout-success__summary-row-title",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("checkout.success.co2Compensation")
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("span", {
                              staticClass:
                                "checkout-success__summary-row-price",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$options.filters.fwgpricecent(
                                    _vm.cartCo2CompensationAmount,
                                    "short"
                                  )
                                )
                              }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.cartTip
                      ? _c(
                          "div",
                          {
                            staticClass:
                              "checkout-success__summary-row checkout-success__summary-row--tip"
                          },
                          [
                            _c("span", {
                              staticClass:
                                "checkout-success__summary-row-title",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$t("checkout.success.tip")
                                )
                              }
                            }),
                            _vm._v(" "),
                            _c("span", {
                              staticClass:
                                "checkout-success__summary-row-price",
                              domProps: {
                                innerHTML: _vm._s(
                                  _vm.$options.filters.fwgpricecent(
                                    _vm.cartTip,
                                    "short"
                                  )
                                )
                              }
                            })
                          ]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c(
                      "div",
                      {
                        staticClass:
                          "checkout-success__summary-row checkout-success__summary-row--total"
                      },
                      [
                        _c("span", {
                          staticClass: "checkout-success__summary-row-title",
                          domProps: {
                            innerHTML: _vm._s(_vm.$t("checkout.success.total"))
                          }
                        }),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "checkout-success__summary-row-price",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.$options.filters.fwgpricecent(
                                _vm.total,
                                "short"
                              )
                            )
                          }
                        })
                      ]
                    )
                  ],
                  2
                ),
                _vm._v(" "),
                _vm.hasFeature("FEATURE_TIP_VARIANTS") && _vm.orderTipSurveyUrl
                  ? [
                      _c(
                        "div",
                        { staticClass: "checkout-success__block" },
                        [
                          _c("h3", {
                            staticClass: "checkout-success__block-title",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("checkout.success.tipSurvey.title")
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "checkout-success__block-text",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("checkout.success.tipSurvey.text")
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("Button", {
                            attrs: {
                              level: "primary",
                              text: _vm.$t("checkout.success.tipSurvey.button"),
                              href: _vm.orderTipSurveyUrl,
                              target: "_blank",
                              arrow: "",
                              small: ""
                            }
                          })
                        ],
                        1
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.orderSurveyUrl
                  ? [
                      _c(
                        "div",
                        { staticClass: "checkout-success__block" },
                        [
                          _c("h3", {
                            staticClass: "checkout-success__block-title",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("checkout.success.survey.title")
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "checkout-success__block-text",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("checkout.success.survey.text")
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("Button", {
                            attrs: {
                              level: "primary",
                              text: _vm.$t("checkout.success.survey.button"),
                              href: _vm.orderSurveyUrl,
                              target: "_blank",
                              arrow: "",
                              small: ""
                            }
                          })
                        ],
                        1
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.hasFeature("FEATURE_ORDER_NPS") && _vm.orderNpsSurveyUrl
                  ? [
                      _c(
                        "div",
                        { staticClass: "checkout-success__block" },
                        [
                          _c("h3", {
                            staticClass: "checkout-success__block-title",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("checkout.success.nps.title")
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("div", {
                            staticClass: "checkout-success__block-text",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("checkout.success.nps.text")
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c("Button", {
                            attrs: {
                              level: "primary",
                              text: _vm.$t("checkout.success.nps.button"),
                              href: _vm.orderNpsSurveyUrl,
                              target: "_blank",
                              arrow: "",
                              small: ""
                            }
                          })
                        ],
                        1
                      )
                    ]
                  : _vm._e(),
                _vm._v(" "),
                _vm.isOrderTypeMain || _vm.isOrderTypeGastroKurier
                  ? _c("div", { staticClass: "checkout-success__loader" }, [
                      _c(
                        "div",
                        { staticClass: "checkout-success__loader-wrapper" },
                        [
                          _c("h1", {
                            staticClass: "checkout-success__headline",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$t("checkout.success.title")
                              )
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "checkout-success__loader-image" },
                            [
                              _c("img", {
                                staticClass:
                                  "checkout-success__loader-image-element",
                                attrs: {
                                  src: _vm.themeImagePath("biker.gif"),
                                  loading: "eager"
                                }
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _c("h2", {
                            staticClass: "checkout-success__subheadline",
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.$options.filters.fwgmark(
                                  _vm.$t(
                                    "checkout.success.loader." + _vm.themeName
                                  )
                                )
                              )
                            }
                          })
                        ]
                      )
                    ])
                  : _vm._e()
              ]
            : [
                _c("h1", {
                  staticClass: "checkout-success__headline",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("checkout.success.titleNotFound"))
                  }
                }),
                _vm._v(" "),
                _c("div", {
                  staticClass: "checkout-success__text",
                  domProps: {
                    innerHTML: _vm._s(_vm.$t("checkout.success.textNotFound"))
                  }
                }),
                _vm._v(" "),
                _c("Button", {
                  attrs: {
                    level: "primary",
                    text: _vm.$t("checkout.success.homeButton"),
                    href: "/" + this.language
                  }
                })
              ]
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }